import socialIcons from "@/components/social-icons/social-icons.vue";
import newsletterForm from "@/components/newsletter-form/newsletter-form.vue";

export default {
  components: {
    socialIcons,
    newsletterForm,
  },
  data() {
    return {
      links: [
        { name: "static-idea", label: "Idea" },
        { name: "static-prices", label: "Opłaty" },
        { name: "faq", label: "FAQ" },
        { name: "static-eu", label: "Projekty UE" },
        { name: "static-terms", label: "Regulamin" },
        { name: "static-privacy-policy", label: "Prywatność" },
        { name: "static-about-us", label: "Kontakt" },
      ],
    };
  },
};
